import _ from 'lodash';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './GameTimer.module.scss';
import Timer from './Timer';
import {
    allPoses,
    promptStages,
    promptPoses,
    wrongPoses,
    rightPoses,
    wrongAnswerTimeoutPoses,
} from '../gameHelpers';
import posed from 'react-pose';
import {keysToSingleValue} from '../utils/objectFactory';

const timerPoses = _.union(promptPoses, wrongPoses, rightPoses);

const Container = posed.div({
    ...keysToSingleValue(timerPoses, {
        y: 0,
        transition: {
            ease: 'easeOut',
            duration: 1000,
        },
    }),
    ...keysToSingleValue(_.difference(allPoses, timerPoses), {
        y: '75vh',
        transition: {
            ease: 'easeIn',
            duration: 1000,
        },
    }),
});

const TimeoutAnimation = posed.div({
    ...keysToSingleValue(wrongAnswerTimeoutPoses, {
        x: 0,
        transition: {
            x: {
                type: 'keyframes',
                values: ['0px', '3px', '-3px', '0'],
                times: [0, 0.25, 0.75, 1],
                loop: 40,
                delay: 0,
                duration: 50,
            },
        },
    }),
});

export default class GameTimer extends Component {
    static propTypes = {
        game: PropTypes.object.isRequired,
        duration: PropTypes.number.isRequired,
        onAlarm: PropTypes.func.isRequired,
    };

    state = {
        start: false,
    };

    componentDidUpdate(prevProps) {
        const prevStage = prevProps.game.stage;
        const nextStage = this.props.game.stage;

        if (prevStage !== nextStage) {
            const needStart = promptStages.includes(nextStage);
            this.setState({start: needStart});
        }
    }

    render() {
        const {duration, onAlarm} = this.props;
        const {start} = this.state;

        return (
            <Container className={styles.timerBox}>
                <TimeoutAnimation>
                    <Timer start={start} duration={duration} onAlarm={onAlarm} />
                </TimeoutAnimation>
            </Container>
        );
    }
}
